/**
 * Constants related to report access restrictions for BNY users
 */

/**
 * User preference key for report access only restriction
 */
export const REPORT_ACCESS_ONLY_PREFERENCE_KEY = 'application:reportAccessOnly';

/**
 * Feature toggle for BNY management report access restrictions
 */
export const REPORT_ACCESS_RESTRICTION_FEATURE_TOGGLE = 'bny-management-report-isd-9062';

/**
 * Feature toggle for Ownership Analysis report access restrictions
 */
export const OWNERSHIP_ANALYSIS_REPORT_ACCESS_RESTRICTION_FEATURE_TOGGLE = 'ownership-analysis-report-isd-22451';
/**
 * Feature toggle for Peer Ownership report access restrictions
 */
export const PEER_OWNERSHIP_REPORT_ACCESS_RESTRICTION_FEATURE_TOGGLE = 'peer-ownership-report-isd-11392516';
/**
 * Account preference key for BNY Branding
 */
export const BNY_BRANDING_PREFERENCE_KEY = 'application:branding';

/**
 * Account preference value for BNY Branding
 */
export const BNY_BRANDING_PREFERENCE_VALUE = 'bny';
